import { ReactNode } from "react";
import { AmplitudeAnalyticsProvider } from "./AmplitudeContext";
import { LocalAnalyticsProvider } from "./LocalAnalyticsProvider";
import { useConfig } from "@/config/ConfigContext";

export const AnalyticsProvider = ({ children }: { children: ReactNode }) => {
  const config = useConfig();
  const isDev = config.VITE_NODE_ENV === "development";

  if (isDev) {
    return <LocalAnalyticsProvider>{children}</LocalAnalyticsProvider>;
  }

  return (
    <AmplitudeAnalyticsProvider apiKey={config.VITE_APP_AMPLITUDE_API_KEY}>
      {children}
    </AmplitudeAnalyticsProvider>
  );
};
